var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InternalNavbar',{attrs:{"navigation":_vm.navigation,"auto-hide":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }